var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-2xl mb-6"},[_vm._v("Inventaire vidéo")]),_c('v-card',{staticClass:"mb-6 pa-2",attrs:{"outlined":""}},[_c('filters')],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('results')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }